var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5161 19.0747H10.5923V36H16.5161V19.0747Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4448 14.2394C16.8192 12.6469 15.8318 11.0524 14.2394 10.678C12.6469 10.3035 11.0524 11.291 10.678 12.8834C10.3035 14.4759 11.2909 16.0704 12.8834 16.4448C14.4759 16.8193 16.0704 15.8318 16.4448 14.2394Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9805 26.6988C35.9805 22.1314 34.9954 19.0747 29.6715 19.0747C27.1131 19.0747 25.3953 20.025 24.6929 21.3589H24.6201V19.0747H19.9014V36H24.8334V27.6108C24.8334 25.3986 25.2513 23.2568 27.9882 23.2568C30.6844 23.2568 30.902 25.7862 30.902 27.754V36H35.9797V26.6988H35.9805Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.597c4da5566e204531fd5acf4a262dd6.svg";
export { ForwardRef as ReactComponent };